import React from "react";
import styled from "styled-components";
import { useCurrentFrame } from "../use-current-frame";
import { spring } from "../Spring";
import { interpolate } from "../interpolate";
// import { interpolate } from "../interpolate";

const Container = styled.div`
    display: inline-flex;
    overflow: hidden;
`;

const Holder = styled.div`
    overflow: hidden;
`;

function WipeAnimation(props) {
    const frame = useCurrentFrame();

    const { children, direction = 'left', contentWidth = 300, contentHeight = 50 } = props;
    const { videoConfig = {} } = props;
    const fps = videoConfig.fps || 30;

    function getTranslateXValue() {
        if (direction !== "left" && direction !== "right") {
            return 0;
        }

        const animation = spring({
            frame: frame / 3.5,
            fps: fps,
            config: {
                damping: 200,
            },
        });

        const width = direction === "left" ? contentWidth : -contentWidth;

        const translateX = interpolate(animation, [0, 1], [width, 0], {
            extrapolateLeft: "clamp",
            extrapolateRight: "clamp",
        });

        return translateX;
    }

    function getTranslateYValue() {
        if (direction !== "up" && direction !== "down") {
            return 0;
        }

        const animation = spring({
            frame: frame / 3.5,
            fps: fps,
            config: {
                damping: 200,
            },
        });

        const height = direction === "up" ? -contentHeight : contentHeight;

        const translateY = interpolate(animation, [0, 1], [height, 0], {
            extrapolateLeft: "clamp",
            extrapolateRight: "clamp",
        });

        return translateY;
    }

    return (
        <Container
            style={{
                transform: `translate(${-getTranslateXValue()}px, ${-getTranslateYValue()}px)`,
            }}
        >
            <Holder
                style={{
                    transform: `translate(${getTranslateXValue()}px, ${getTranslateYValue()}px)`,
                }}
            >
                {children}
            </Holder>
        </Container>
    );
}

export default React.memo(WipeAnimation);
